import React from "react";
import OwlCarousel from "react-owl-carousel3";
import VisibilitySensor from "react-visibility-sensor";
import { Link } from "react-router-dom";
import ModalVideo from "react-modal-video";

const options = {
  loop: true,
  nav: true,
  dots: false,
  autoplayHoverPause: false,
  autoplay: true,
  autoplayTimeout: 3000,
  items: 1,
  navText: [
    "<i class='icofont-swoosh-left'></i>",
    "<i class='icofont-swoosh-right'></i>",
  ],
};

class MainBanner extends React.Component {
  state = {
    isOpen: false,
  };

  openModal = () => {
    this.setState({ isOpen: true });
  };
  render() {
    return (
      <React.Fragment>
        <ModalVideo
          channel="youtube"
          isOpen={this.state.isOpen}
          videoId="cRXm1p-CNyk"
          onClose={() => this.setState({ isOpen: false })}
        />

        <OwlCarousel
          className="home-slides owl-carousel owl-theme"
          {...options}
        >
          {/* <div className="main-banner item-bg3">
            <div className="d-table">
              <div className="d-table-cell">
                <div className="container">
                  <VisibilitySensor>
                    {({ isVisible }) => (
                      <div className="main-banner-content">
                        <p className={isVisible ? "animated fadeInDown" : ""}>
                          Where Every Moment Becomes an Experience
                        </p>
                        <h1 className={isVisible ? "animated fadeInUp" : ""}>
                          Celebrate, Explore, and Escape!
                        </h1>
                        <ul>
                          <li style={{ display: 'flex'}}>
                            <img
                              src="/assets/images/noun-star-7308989.svg"
                              height={40}
                              style={{ width: "min-content" }}
                            />
                            Curated Events |{" "}
                            <img
                              src="/assets/images/noun-earth-962852.svg"
                              height={30}
                              style={{ width: "min-content" }}
                            />
                            Tailored Travel |{" "}
                            <img
                              src="/assets/images/noun-party-7376992.svg"
                              height={40}
                              style={{ width: "min-content" }}
                            />{" "}
                            Unforgettable Memories
                          </li>
                        </ul>
                        <div className="button-box">
                          <Link
                            to="#"
                            className={`btn btn-primary ${
                              isVisible ? "animated fadeInDown" : ""
                            }`}
                          >
                            Buy Tickets Now!
                          </Link>
                          <Link 
                                                        onClick={e => {e.preventDefault(); this.openModal()}}
                                                        to="#" 
                                                        className={
                                                            `video-btn popup-youtube ${isVisible ? "animated fadeInDown" : ""}`
                                                        }
                                                    >
                                                        <i className="icofont-ui-play"></i> Watch Pormo Video
                                                    </Link>
                        </div>
                      </div>
                    )}
                  </VisibilitySensor>
                </div>
              </div>
            </div>
          </div> */}
          
          <div id="banner" className="main-banner item-bg4">
            <div className="d-table">
              <div className="d-table-cell">
                <div className="container">
                  <VisibilitySensor>
                    {({ isVisible }) => (
                      <div className="main-banner-content banner-content-center">
                        <p className={isVisible ? "animated fadeInDown" : ""}>
                          Unforgettable Celebrations
                          {/* <span>Celebrations</span> */}
                        </p>
                        <h1 className={isVisible ? "animated fadeInUp" : ""}>
                          New Year Parties
                          {/* <span>Biggest</span> <br /> Conference{" "} */}
                          {/* <b>2</b>
                          <b>0</b>
                          <b>2</b>
                          <b>0</b> */}
                        </h1>
                        <ul className={isVisible ? "animated zoomIn" : ""}>
                          <li>
                            {/* <i className="icofont-compass"></i> Yellow Street, */}
                            Welcome the new year with dazzling themes, vibrant
                            music, and memories to cherish forever.
                          </li>
                          {/* <li>
                            <i className="icofont-calendar"></i> 23-27 Jan, 2020
                          </li> */}
                        </ul>
                        <div className="button-box">
                          <a
                            href="whatsapp://send?phone=+918108818113"
                            className="btn btn-primary"
                          >
                            Enquire Now!
                          </a>
                          {/* <Link
                            onClick={(e) => {
                              e.preventDefault();
                              this.openModal();
                            }}
                            to="#"
                            className={`video-btn popup-youtube ${
                              isVisible ? "animated fadeInDown" : ""
                            }`}
                          >
                            <i className="icofont-ui-play"></i> Watch Pormo
                            Video
                          </Link> */}
                        </div>
                      </div>
                    )}
                  </VisibilitySensor>
                </div>
              </div>
            </div>
          </div>

          <div className="main-banner item-bg42">
            <div className="d-table">
              <div className="d-table-cell">
                <div className="container">
                  <VisibilitySensor>
                    {({ isVisible }) => (
                      <div className="main-banner-content banner-content-center">
                        <p className={isVisible ? "animated fadeInDown" : ""}>
                          Discover the World
                          {/* <span>Celebrations</span> */}
                        </p>
                        <h1 className={isVisible ? "animated fadeInUp" : ""}>
                          Travel Packages
                          {/* <span>Biggest</span> <br /> Conference{" "} */}
                          {/* <b>2</b>
                          <b>0</b>
                          <b>2</b>
                          <b>0</b> */}
                        </h1>
                        <ul className={isVisible ? "animated zoomIn" : ""}>
                          <li>
                            {/* <i className="icofont-compass"></i> Yellow Street, */}
                            Handpicked journeys to stunning destinations,
                            tailored just for you.
                          </li>
                          {/* <li>
                            <i className="icofont-calendar"></i> 23-27 Jan, 2020
                          </li> */}
                        </ul>
                        <div className="button-box">
                          <a
                            href="whatsapp://send?phone=+918108818113"
                            className="btn btn-primary"
                          >
                            Enquire Now!
                          </a>
                          {/* <Link
                            onClick={(e) => {
                              e.preventDefault();
                              this.openModal();
                            }}
                            to="#"
                            className={`video-btn popup-youtube ${
                              isVisible ? "animated fadeInDown" : ""
                            }`}
                          >
                            <i className="icofont-ui-play"></i> Watch Pormo
                            Video
                          </Link> */}
                        </div>
                      </div>
                    )}
                  </VisibilitySensor>
                </div>
              </div>
            </div>
          </div>

          <div className="main-banner item-bg43">
            <div className="d-table">
              <div className="d-table-cell">
                <div className="container">
                  <VisibilitySensor>
                    {({ isVisible }) => (
                      <div className="main-banner-content banner-content-center">
                        <p className={isVisible ? "animated fadeInDown" : ""}>
                          Creative Excellence
                          {/* <span>Celebrations</span> */}
                        </p>
                        <h1 className={isVisible ? "animated fadeInUp" : ""}>
                          Wedding Creatives
                          {/* <span>Biggest</span> <br /> Conference{" "} */}
                          {/* <b>2</b>
                          <b>0</b>
                          <b>2</b>
                          <b>0</b> */}
                        </h1>
                        <ul className={isVisible ? "animated zoomIn" : ""}>
                          <li>
                            {/* <i className="icofont-compass"></i> Yellow Street, */}
                            From décor to themes, we craft magical moments for
                            your special day.
                          </li>
                          {/* <li>
                            <i className="icofont-calendar"></i> 23-27 Jan, 2020
                          </li> */}
                        </ul>
                        <div className="button-box">
                          <a
                            href="whatsapp://send?phone=+918108818113"
                            className="btn btn-primary"
                          >
                            Enquire Now!
                          </a>
                          {/* <Link
                            onClick={(e) => {
                              e.preventDefault();
                              this.openModal();
                            }}
                            to="#"
                            className={`video-btn popup-youtube ${
                              isVisible ? "animated fadeInDown" : ""
                            }`}
                          >
                            <i className="icofont-ui-play"></i> Watch Pormo
                            Video
                          </Link> */}
                        </div>
                      </div>
                    )}
                  </VisibilitySensor>
                </div>
              </div>
            </div>
          </div>

          <div className="main-banner item-bg44">
            <div className="d-table">
              <div className="d-table-cell">
                <div className="container">
                  <VisibilitySensor>
                    {({ isVisible }) => (
                      <div className="main-banner-content banner-content-center">
                        <p className={isVisible ? "animated fadeInDown" : ""}>
                          Spectacular Performances
                          {/* <span>Celebrations</span> */}
                        </p>
                        <h1 className={isVisible ? "animated fadeInUp" : ""}>
                          Concerts
                          {/* <span>Biggest</span> <br /> Conference{" "} */}
                          {/* <b>2</b>
                          <b>0</b>
                          <b>2</b>
                          <b>0</b> */}
                        </h1>
                        <ul className={isVisible ? "animated zoomIn" : ""}>
                          <li>
                            {/* <i className="icofont-compass"></i> Yellow Street, */}
                            Feel the magic of live music with flawless planning
                            and execution..
                          </li>
                          {/* <li>
                            <i className="icofont-calendar"></i> 23-27 Jan, 2020
                          </li> */}
                        </ul>
                        <div className="button-box">
                          <a
                            href="whatsapp://send?phone=+918108818113"
                            className="btn btn-primary"
                          >
                            Enquire Now!
                          </a>
                          {/* <Link
                            onClick={(e) => {
                              e.preventDefault();
                              this.openModal();
                            }}
                            to="#"
                            className={`video-btn popup-youtube ${
                              isVisible ? "animated fadeInDown" : ""
                            }`}
                          >
                            <i className="icofont-ui-play"></i> Watch Pormo
                            Video
                          </Link> */}
                        </div>
                      </div>
                    )}
                  </VisibilitySensor>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="main-banner item-bg5">
            <div className="d-table">
              <div className="d-table-cell">
                <div className="container">
                  <VisibilitySensor>
                    {({ isVisible }) => (
                      <div className="main-banner-content">
                        <p className={isVisible ? "animated fadeInDown" : ""}>
                          "Where Every Moment Becomes an Experience"
                        </p>
                        <h1 className={isVisible ? "animated fadeInUp" : ""}>
                          World Advanced <span>Biggest</span> <br /> Conference{" "}
                          <b>2</b>
                          <b>0</b>
                          <b>2</b>
                          <b>0</b>
                        </h1>
                        <ul className={isVisible ? "animated zoomIn" : ""}>
                          <li>
                            <i className="icofont-compass"></i> Yellow Street,
                            United State
                          </li>
                          <li>
                            <i className="icofont-calendar"></i> 23-27 Jan, 2020
                          </li>
                        </ul>
                        <div className="button-box">
                          <Link
                            to="#"
                            className={`btn btn-primary ${
                              isVisible ? "animated fadeInDown" : ""
                            }`}
                          >
                            Buy Tickets Now!
                          </Link>
                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              this.openModal();
                            }}
                            to="#"
                            className={`video-btn popup-youtube ${
                              isVisible ? "animated fadeInDown" : ""
                            }`}
                          >
                            <i className="icofont-ui-play"></i> Watch Pormo
                            Video
                          </Link>
                        </div>
                      </div>
                    )}
                  </VisibilitySensor>
                </div>
              </div>
            </div>
          </div> */}
        </OwlCarousel>
      </React.Fragment>
    );
  }
}

export default MainBanner;
